import { render, staticRenderFns } from "./NeimengPatientBaseInfoForm.vue?vue&type=template&id=0174d2c2&scoped=true"
import script from "./NeimengPatientBaseInfoForm.vue?vue&type=script&lang=js"
export * from "./NeimengPatientBaseInfoForm.vue?vue&type=script&lang=js"
import style0 from "./NeimengPatientBaseInfoForm.vue?vue&type=style&index=0&id=0174d2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0174d2c2",
  null
  
)

export default component.exports